import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrandProvider } from '@shared-ui/brand-context';
import { EGDSIconSize, EGDSIcon } from '@egds/react-core/icons';

/*
  This function takes icon name and brand as a parameter and renders the svg into a div
*/
const buildIcon = (iconName, className, brand, iconSize = EGDSIconSize.MEDIUM) => {
  const icon = React.createElement(BrandProvider, {
    config: brand
  }, React.createElement(EGDSIcon, {
    name: `icon__${iconName}`,
    className: `${className} ${iconName}`,
    size: iconSize
  }));
  const container = document.createElement('div');
  ReactDOM.render(icon, container);
  return container;
};
const buildMinipin = () => {
  const miniPinSvg = React.createElement("svg", {
    width: "18",
    height: "12",
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", null, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "18",
    height: "12",
    rx: "6",
    fill: "white"
  }), React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "17",
    height: "11",
    rx: "5.5",
    stroke: "#676A7C"
  })));
  const container = document.createElement('div');
  ReactDOM.render(miniPinSvg, container);
  return container;
};
export { buildIcon, buildMinipin };